const TOKEN_KEY = "exam-token";
const UTYPE = "user-type";

function getToken(){
    return localStorage.getItem(TOKEN_KEY) || "";
}

function setToken(token) {
    return localStorage.setItem(TOKEN_KEY, token);
}

function clearToken() {
    return localStorage.removeItem(TOKEN_KEY);
}
function getUtype() {
    return localStorage.getItem(UTYPE) || "";
}
function setUtype(type) {
    return localStorage.setItem(UTYPE, type);
}
function clearUtype() {
    return localStorage.removeItem(UTYPE);
}

export { getToken, setToken, clearToken, getUtype, setUtype, clearUtype };
